import PropTypes from 'prop-types';
import React, { Component } from 'react';
import NotificationSystem from './react-notification-system/NotificationSystem';
import { injectIntl, intlShape } from 'react-intl';

class NotificationsDisplay extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    notifications: PropTypes.array.isRequired,
    onRemoveNotification: PropTypes.func.isRequired,
  };

  _notificationSystem = null;

  componentDidMount() {
    this._notificationSystem = this.notificationSystem;
    this._showNotifications(this.props);
  }

  _showNotifications(props) {
    const notifs = props.notifications;
    if (notifs.length > 0) {
      for (const notif of notifs) {
        // TODO - This is hella confusing. The message of the message of the notification. Argg
        // The message of the notif is actually the notification that you originally dispatched.
        // Urg.
        let message = notif.message;
        if (message.hasOwnProperty('message')) {
          message = this.props.intl.formatMessage(
            message.message,
            message.params
          );
        } else if (
          message.hasOwnProperty('id') &&
          message.hasOwnProperty('defaultMessage')
        ) {
          message = this.props.intl.formatMessage(message);
        } else {
          message = message.toString();
        }
        if (!message || !notif.uid) {
          continue;
        }
        const reactNotification = {
          uid: notif.uid,
          message: message,
          level: notif.type,
          position: 'tc',
          onRemove: notification =>
            props.onRemoveNotification(notification.uid),
          action: notif.message.action,
          dismissible: notif.message.hasOwnProperty('dismissible')
            ? notif.message.dismissible
            : true,
          dataTestName: notif.dataTestName,
        };
        if (notif.message.hasOwnProperty('autoDismiss')) {
          reactNotification.autoDismiss = notif.message.autoDismiss;
        }
        this._notificationSystem.addNotification(reactNotification);
      }
    } else {
      this._notificationSystem.clearNotifications();
    }
  }

  componentWillReceiveProps(nextProps) {
    this._showNotifications(nextProps);
  }

  render() {
    const notificationStyle = {
      Containers: {
        DefaultStyle: {
          width: 450,
        },
      },
      NotificationItem: {
        DefaultStyle: {
          padding: '20px',
          fontSize: '18px',
          borderTop: 'none',
          borderRadius: '2px',
          textAlign: 'center',
          wordWrap: 'break-word',
        },

        success: {
          backgroundColor: 'var(--accentColor)',
          color: 'white',
          stroke: 'var(--accentColor)',
          fill: 'white',
        },

        error: {
          backgroundColor: '#ff3860',
          color: 'white',
          stroke: '#ff3860',
          strokeLinecap: 'square',
          fill: 'white',
        },

        warning: {
          backgroundColor: '#ffdd57',
          color: '#2b2b2b',
          stroke: 'white',
          fill: '#cda300',
        },

        info: {
          backgroundColor: '#209cee',
          color: 'white',
          stroke: 'white',
          fill: '#0b598e',
        },
      },
      Dismiss: {
        DefaultStyle: {
          width: '25px',
          height: '25px',
        },
      },
      Action: {
        DefaultStyle: {
          borderRadius: '4px',
          padding: '10px 20px',
          fontSize: '12px',
        },

        success: {
          backgroundColor: '#0f5041',
        },

        error: {
          backgroundColor: '#d9534f',
        },

        warning: {
          backgroundColor: '#cda300',
        },

        info: {
          backgroundColor: '#0b598e',
        },
      },
      ActionWrapper: {
        DefaultStyle: {
          textAlign: 'center',
        },
      },
    };

    return (
      <NotificationSystem
        style={notificationStyle}
        ref={input => {
          this.notificationSystem = input;
        }}
      />
    );
  }
}

export default injectIntl(NotificationsDisplay);



// WEBPACK FOOTER //
// ./src/view/App/NotificationDisplay/NotificationDisplay.js